import React, {useEffect, useState} from 'react';
import {RFValue} from 'react-native-responsive-fontsize';

import {
  Keyboard,
  KeyboardAvoidingView,
  Platform,
  TouchableWithoutFeedback,
} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {SafeAreaView} from 'react-native-safe-area-context';
import analytics from '@react-native-firebase/analytics';

import {Button} from '../../../components/Interface/Forms/Buttons/Button';
import {Header} from '../../../components/Interface/Headers/Header';

import {Container, Content, Form, InputGroup, Footer} from './styles';

import {Titles} from '../../../components/Interface/Typographies/Titles';
import {Input} from '../../../components/Interface/Forms/Inputs/Input';
import {Picker} from '../../../components/Interface/Forms/Inputs/Picker';

import {Loading} from '../../../components/Interface/Loadings/Loading';
import {api, apiFipe, apiZignet, tokenFipe} from '../../../services/api';
import {ConvenioDataDTO, ConveniosDTO} from '../../../dtos/DebitsDTO';
import {FipeResponseDTO} from '../../../dtos/FipeDTO';
import {PromoModal} from '../../../components/Interface/PromoModal';

interface PickerItem {
  label: string;
  value: string;
}

export function AddVehicle() {
  const navigation = useNavigation();

  const [enabled, setEnabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [jaPontuado, setJaPontuado] = useState(false);

  const [convenios, setConvenios] = useState<ConvenioDataDTO[]>(
    [] as ConvenioDataDTO[],
  );
  const [conveniosPickerData, setConveniosPickerData] = useState<PickerItem[]>(
    [] as PickerItem[],
  );
  const [typesDebtPickerData, setTypesDebtPickerData] = useState<PickerItem[]>(
    [] as PickerItem[],
  );

  const [showPlate, setShowPlate] = useState(false);
  const [showRenavam, setShowRenavam] = useState(false);
  const [showDocument, setShowDocument] = useState(false);
  const [showTypeDebt, setShowTypeDbt] = useState(false);

  const [convenio, setConvenio] = useState('NULL');
  const [placa, setPlaca] = useState('');
  const [renavam, setRenavam] = useState('');
  const [documento, setDocumento] = useState('');
  const [tipo, setTipo] = useState('NULL');

  function handleChangeConvenioText(extracted: any) {
    setConvenio(extracted);

    const findClient = convenios.find(item => item.uf === extracted);

    if (findClient?.plate.required) {
      setShowPlate(true);
    } else {
      setShowPlate(false);
    }

    if (findClient?.renavam.required) {
      setShowRenavam(true);
    } else {
      setShowRenavam(false);
    }

    if (findClient?.document.required) {
      setShowDocument(true);
    } else {
      setShowDocument(false);
    }

    if (findClient?.typeDebt.required) {
      setShowTypeDbt(true);

      let formattedData: PickerItem[] = [] as PickerItem[];
      findClient.typeDebt.options.map(item => {
        formattedData.push({
          label: item,
          value: item,
        });
      });

      setTypesDebtPickerData(formattedData);
    } else {
      setShowTypeDbt(false);
    }
  }

  function handleChangePlacaText(extracted: any) {
    setPlaca(extracted);
  }

  function handleChangeRenavamText(extracted: any) {
    setRenavam(extracted);
  }

  function handleChangeDocumentText(extracted: any) {
    setDocumento(extracted);
  }

  function handleChangeTypeText(extracted: any) {
    setTipo(extracted);
  }

  async function fetchFipe() {
    setIsLoading(true);
    await apiFipe
      .post('/getplacafipe', {
        placa: placa,
        token: tokenFipe,
      })
      .then(({data}) => {
        const {codigo} = data as FipeResponseDTO;
        if (codigo === 1) {
          return handleCriaConsulta();
        }
        if (codigo === 763) {
          setIsLoading(false);

          return navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.goBack(),
            buttonText: 'Tentar novamente',
            closeIconAction: () => navigation.goBack(),
            text: 'Placa não encontrada, verifique e tente novamente.',
            title: 'Ocorreu um problema',
          });
        }
        if (codigo === 759) {
          setIsLoading(false);

          return navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.goBack(),
            buttonText: 'Tentar novamente',
            closeIconAction: () => navigation.goBack(),
            text: 'Veículo não encontrado. Verifique a placa e tente novamente.',
            title: 'Ocorreu um problema',
          });
        }

        setIsLoading(false);

        return navigation.navigate('ConfirmationScreen', {
          type: 'error',
          buttonAction: () => navigation.goBack(),
          buttonText: 'Tentar novamente',
          closeIconAction: () => navigation.goBack(),
          text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
          title: 'Ocorreu um problema',
        });
      })
      .catch(() => {
        setIsLoading(false);
        return navigation.navigate('ConfirmationScreen', {
          type: 'error',
          buttonAction: () => navigation.navigate('Initial'),
          buttonText: 'Ir para a tela inicial',
          closeIconAction: () => navigation.navigate('Initial'),
          text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
          title: 'Ocorreu um problema',
        });
      });
  }

  async function handleCriaConsulta() {
    try {
      const response = await api.post('/criaVeiculo', {
        renavam,
        placa,
        documento,
        detran: convenio,
      });

      if (response.data) {
        analytics().logEvent('cadastro_veiculo_sucesso_alerta_multas');

        if (response.data.message) {
          setJaPontuado(true);
        } else {
          navigation.goBack();
        }
      }
    } catch ({response}: any) {
      if (response.data.error) {
        return navigation.navigate('ConfirmationScreen', {
          type: 'error',
          title: 'Veículo não cadastrado',
          text: response.data.error,
          buttonAction: () => navigation.goBack(),
          buttonText: 'Tentar novamente',
          closeIconAction: () => navigation.goBack(),
        });
      }

      return navigation.navigate('ConfirmationScreen', {
        type: 'error',
        buttonAction: () => navigation.navigate('Initial'),
        buttonText: 'Ir para a tela inicial',
        closeIconAction: () => navigation.navigate('Initial'),
        text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
        title: 'Ocorreu um problema',
      });
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    async function fetchConvenios() {
      await apiZignet
        .get('/get-clients')
        .then(response => {
          const {success, data} = response.data as ConveniosDTO;

          if (success) {
            let formattedData: PickerItem[] = [] as PickerItem[];
            data.map((item: ConvenioDataDTO) => {
              formattedData.push({
                label: item.uf,
                value: item.uf.toString(),
              });
            });

            if (isMounted) {
              setConvenios(data);
              setConveniosPickerData(formattedData);
            }
          } else {
            navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.goBack(),
              buttonText: 'Tentar novamente',
              closeIconAction: () => navigation.navigate('Initial'),
              text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
              title: 'Não foi possível consultar os débitos',
            });
          }
        })
        .catch(({response}) => {
          if (response.data.message) {
            return navigation.navigate('ConfirmationScreen', {
              type: 'error',
              buttonAction: () => navigation.navigate('Initial'),
              buttonText: 'Voltar para a tela inicial',
              closeIconAction: () => navigation.navigate('Initial'),
              text: response.data.message,
              title: 'Ocorreu um problema',
            });
          }

          return navigation.navigate('ConfirmationScreen', {
            type: 'error',
            buttonAction: () => navigation.navigate('Initial'),
            buttonText: 'Voltar para a tela inicial',
            closeIconAction: () => navigation.navigate('Initial'),
            text: 'Ocorreu um erro no processamento. Entre em contato com nosso suporte para obter ajuda.',
            title: 'Ocorreu um problema',
          });
        })
        .finally(() => {
          if (isMounted) {
            setIsLoading(false);
            isMounted = false;
          }
        });
    }
    fetchConvenios();

    analytics().logEvent('tela_cadastro_veiculo_alerta_multas');

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (convenio === 'NULL') {
      setEnabled(false);
    } else if (showPlate && placa.length < 7) {
      setEnabled(false);
    } else if (
      (showRenavam && renavam.length < 11) ||
      (showDocument && documento.length < 11)
    ) {
      setEnabled(false);
    } else if (showTypeDebt && tipo === 'NULL') {
      setEnabled(false);
    } else {
      setEnabled(true);
    }
  }, [placa, renavam, documento, tipo, convenio]);

  function handleConfirmJaPontuado() {
    setJaPontuado(false);
    navigation.goBack();
  }

  return (
    <>
      {isLoading && <Loading />}

      <TouchableWithoutFeedback onPress={() => Platform.OS !== "web" && Keyboard.dismiss()}>
        <Container>
          <KeyboardAvoidingView
            behavior="position"
            contentContainerStyle={{paddingBottom: RFValue(20)}}>
            <Header icon="chevron-left" />

            <Content>
              <Titles
                title="Dados do veículo"
                subtitle="Digite abaixo os dados do seu veículo para ativar o alerta de multas."
              />

              <Form>
                <InputGroup>
                  <Picker
                    label="Estado (Detran)"
                    placeholder={{
                      label: 'Escolha um Detran',
                      value: 'NULL',
                    }}
                    items={conveniosPickerData}
                    onChangeValue={item => handleChangeConvenioText(item)}
                  />
                </InputGroup>

                {showPlate && (
                  <InputGroup>
                    <Input
                      labelText="Placa do veículo"
                      keyboardType="default"
                      placeholder="Digite a placa do veículo"
                      mask={'[AAA]-[0-99]'}
                      onChangeText={(formatted, extracted) =>
                        handleChangePlacaText(extracted)
                      }
                      value={placa}
                      autoCapitalize="characters"
                    />
                  </InputGroup>
                )}

                {showRenavam && (
                  <InputGroup>
                    <Input
                      labelText="Renavam"
                      keyboardType="number-pad"
                      placeholder="Digite o renavam do veículo"
                      mask={'[00000000000000]'}
                      onChangeText={(formatted, extracted) =>
                        handleChangeRenavamText(extracted)
                      }
                      value={renavam}
                    />
                  </InputGroup>
                )}

                {showDocument && (
                  <InputGroup>
                    <Input
                      labelText="CPF/CNPJ do proprietário"
                      keyboardType="number-pad"
                      placeholder="Digite o CPF/CNPJ do proprietário"
                      mask={
                        documento.length <= 11
                          ? '[000].[000].[000]-[000]'
                          : '[00].[000].[000]/[0000]-[00]'
                      }
                      onChangeText={(formatted, extracted) =>
                        handleChangeDocumentText(extracted)
                      }
                      value={documento}
                    />
                  </InputGroup>
                )}

                {showTypeDebt && (
                  <Picker
                    label="Tipo de débito"
                    placeholder={{
                      label: 'Escolha um tipo de débito',
                      value: 'NULL',
                    }}
                    items={typesDebtPickerData}
                    onChangeValue={item => handleChangeTypeText(item)}
                  />
                )}
              </Form>
            </Content>
          </KeyboardAvoidingView>
        </Container>
      </TouchableWithoutFeedback>
      <Footer>
        <SafeAreaView>
          <Button title="Ativar alerta" enabled={enabled} onPress={fetchFipe} />
          <PromoModal
            title="Veículo já pontuado."
            text="O veículo foi cadastrado, mas você não ganhou BaratinhaZ na sua conta. Isso aconteceu porque alguém já cadastrou esse mesmo veículo antes e levou os pontos."
            isVisible={jaPontuado}
            buttonAction={handleConfirmJaPontuado}
            buttonText="Ok, entendi"
          />
        </SafeAreaView>
      </Footer>
    </>
  );
}
